<div mat-dialog-title class="!text-base">{{title}}</div>
<div mat-dialog-content class="py-0 !max-h-[75vh]">
    <div *ngFor="let entry of entries.controls; let i = index; let last = last"
        [formGroup]="entry"
        class="pt-2"
        [class.border-b]="!last" [class.border-gray-200]="!last" [class.mb-4]="!last">

        <div *ngIf="!isEdit" class="flex items-center justify-between mb-2">
            <span class="font-bold text-sm">Plataforma {{ i + 1 }}</span>
            <button *ngIf="entries.length > 1" mat-icon-button type="button" (click)="removeEntry(i)"
                matTooltip="Quitar esta plataforma">
                <mat-icon>close</mat-icon>
            </button>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-x-4 gap-y-2">
            <mat-form-field class="w-full">
                <mat-label>Plataforma</mat-label>
                <mat-select formControlName="platform" required
                    [placeholder]="loadingCatalogs ? 'Cargando...' : ''">
                    <mat-option *ngIf="loadingCatalogs" disabled>Cargando...</mat-option>
                    <mat-option *ngFor="let p of platforms" [value]="p.id">{{p.descripcion}}</mat-option>
                </mat-select>
                <mat-error>Completa este campo.</mat-error>
            </mat-form-field>
            <mat-form-field class="w-full">
                <mat-label>Clasificación</mat-label>
                <mat-select formControlName="classification" required>
                    <mat-option *ngFor="let c of classificationsFor(entry)" [value]="c.id">{{c.descripcion}}</mat-option>
                </mat-select>
                <mat-error>Completa este campo.</mat-error>
            </mat-form-field>

            <!-- Tipo de valorización, justo debajo de Plataforma y Clasificación -->
            <ng-container *ngIf="entry.controls.platform.value">
                <!-- Normal: solo el texto -->
                <div *ngIf="!tipoValorizacionFor(entry)" class="md:col-span-2 text-black mb-[14px]">
                    <span class="font-bold">Tipo de valorización:</span> Normal
                </div>

                <!-- Por segundo / por cm²: aviso compacto con la explicación -->
                <div *ngIf="tipoValorizacionFor(entry)"
                    class="md:col-span-2 mb-[14px] flex items-start gap-2 rounded border border-yellow-300 bg-yellow-50 px-3 py-1.5 text-sm text-yellow-900">
                    <mat-icon class="!text-yellow-600 shrink-0 icon-alert">warning</mat-icon>
                    <span *ngIf="tipoValorizacionFor(entry) === 'tiempo'">
                        <span class="font-bold">Tipo de valorización: Por segundo.</span>
                        Recuerda que la valorización en US$ que coloques se multiplicará por cada segundo de duración al crear
                        tu impacto en tu detalle de plan de medios.
                    </span>
                    <span *ngIf="tipoValorizacionFor(entry) === 'impreso'">
                        <span class="font-bold">Tipo de valorización: Por cm².</span>
                        Recuerda que la valorización que coloques se multiplicará por cada cm<sup>2</sup> de hoja impresa al
                        crear tu impacto en tu detalle de plan de medios.
                    </span>
                </div>
            </ng-container>

            <mat-form-field class="w-full md:col-span-2">
                <mat-label>Nº Señal / URL</mat-label>
                <input matInput type="text" autocomplete="off" formControlName="url" required>
                <mat-error>Completa este campo.</mat-error>
            </mat-form-field>
            <mat-form-field class="w-full">
                <mat-label>Valor (USD)</mat-label>
                <input matInput type="number" autocomplete="off" formControlName="valor" [required]="valorizacionObligatoria">
                <mat-error *ngIf="entry.controls.valor.hasError('required')">Completa este campo.</mat-error>
                <mat-error *ngIf="entry.controls.valor.hasError('greaterThanZero')">Debe ser mayor a 0.</mat-error>
            </mat-form-field>
            <mat-form-field class="w-full">
                <mat-label>Alcance</mat-label>
                <input matInput type="number" autocomplete="off" formControlName="scope" [required]="valorizacionObligatoria">
                <mat-error *ngIf="entry.controls.scope.hasError('required')">Completa este campo.</mat-error>
                <mat-error *ngIf="entry.controls.scope.hasError('greaterThanZero')">Debe ser mayor a 0.</mat-error>
            </mat-form-field>
            <mat-form-field class="w-full md:col-span-2">
                <textarea matInput placeholder="Observación" formControlName="observation"></textarea>
            </mat-form-field>
        </div>
    </div>

    <button *ngIf="!isEdit" mat-stroked-button color="primary" type="button" class="mt-2 mb-2" (click)="addEntry()">
        <mat-icon>add</mat-icon>
        Agregar otra plataforma
    </button>
</div>

<div mat-dialog-actions align="end" class="!px-6 !mt-4 ">
    <button mat-stroked-button color="primary" class="me-4" mat-dialog-close type="button">Cancelar</button>
    <adp-button-icon (clicked)="onSubmit()" color="primary" [disabled]="entries.invalid || loadingCatalogs"
        [loading]="loading" [label]="isEdit || entries.length === 1 ? 'Guardar' : 'Guardar (' + entries.length + ')'"></adp-button-icon>
</div>
